// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(auth)\\_layout.tsx"); } },
  "./(auth)/otp.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(auth)\\otp.tsx"); } },
  "./(auth)/phone.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(auth)\\phone.tsx"); } },
  "./(auth)/setup.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(auth)\\setup.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(tabs)\\_layout.tsx"); } },
  "./(tabs)/calendar.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(tabs)\\calendar.tsx"); } },
  "./(tabs)/chat.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(tabs)\\chat.tsx"); } },
  "./(tabs)/reminders.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(tabs)\\reminders.tsx"); } },
  "./(tabs)/settings.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\(tabs)\\settings.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\_layout.tsx"); } },
  "./checkout.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\checkout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\index.tsx"); } },
  "./reminder/[seq].tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\reminder\\[seq].tsx"); } },
  "./subscribe.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\subscribe.tsx"); } },
  "./support-chat.tsx": { enumerable: true, get() { return require("C:\\FISHMEMORY\\apps\\mobile\\app\\support-chat.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;